<template lang="html">
    <body class="form">
        <div class="form__container">
            <h1 class="header-1 form__header">
                Completează adresa de e-mail
            </h1>
            
            <div class="form__details">
                <img src="@/assets/images/facebook.png" class="form__details--icon" />
                <div class="form__details--text">
                    {{name}}
                </div>
            </div>
            
            <div class="form__info">
                Folosind serviciul de autentificare Facebook, nu a fost detectată adresa de e-mail.
                Pentru a continua, aceasta poate fi completă în acest pas.
            </div>
            
            <div class="form__input">
                <UiInput 
                    label="Adresă de email"
                    type="email"
                    placeholder="user@gmail.com"
                    :value="email"
                    :disabled="isLoading"
                    :error="errors.email"
                    @input="email = $event, validateEmail()"
                    @blur="validateEmail"
                    @keyup="loginOnEnter"
                />
                <div v-if="apiErrors" class="main-form__text">
                    <span v-if="typeof apiErrors == 'string'" class="error">
                        {{apiErrors}}
                    </span>
                    <span v-else-if="typeof apiErrors == 'object'" 
                        v-for="error in apiErrors" :key="error" class="error">
                        {{error}}<br>
                    </span>
                </div>
            </div>
            
            <div class="form__submit">
                <UiButton 
                    shape="square"
                    name="Continuă"
                    :disabled="disabledButton"
                    :name="isLoading ? 'Se incarcă...' : 'Continuă'"
                    @click="sendRegister"
                />
            </div>
            
			<a @click="logout" class="form__disconnect">				
                <div class="form__disconnect--text">
                    Renunță
                </div>
			</a>
        </div>
    </body>
</template>

<script>
    import UiInput from '@/components/ui/Input'
    import UiButton from '@/components/ui/Button'

    import { mapActions } from 'vuex'

    export default {
        components: { UiInput, UiButton },
        data() {
            return {
                isLoading: false,
                fbId: null,
                name: '',
                email: '',
                errors: {
                    email: ''
                },
                apiErrors: ''
            };
        },
        mounted() {
            this.name = this.$route.query.name;
            this.fbId = this.$route.query.fbId;
        },
        methods: {
            ...mapActions({
                connectWith: 'user/connectWith'
            }),
            validateEmailFormat(email) {
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            validateEmail() {
                this.apiErrors = null;
                if(this.email.length > 0 && !this.validateEmailFormat(this.email))
                    this.errors.email = 'Adresa de email introdusă este invalidă!';
                else this.errors.email = '';
            },
            loginOnEnter(event) {
                if (event.keyCode === 13) {
                    this.sendRegister();
                }
            },
			logout() {
				this.$router.push('/client/register');
			},
            
            sendRegister() {
                console.log(this.fbId, this.email, this.name);
                if(this.email && this.fbId && this.name) {
                    this.connectWith({
                        platform: 'facebook',
                        payload: {
                            id: this.fbId,
                            name: this.name,
                            email: this.email
                        }
                    });
                }
            }
        },
        computed: {
            disabledButton() {
                if (this.isLoading) return true;
                if(this.email.length == 0 || this.errors.email.length)
                    return true;
                return false;
            }
        },
        watch: {
            "$store._modules.root.state.notification.notification.title"(notification) {
                this.isLoading = false;
                if (Array.isArray(notification)) {
                    this.apiErrors = notification;
                } else {
                    this.apiErrors = [ notification ];
                }
            }
        }
    }
</script>

<style lang="scss">
    body.form>* {
        &,
        &::before,
        &::after {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: "DIN Pro", sans-serif;
        }
    }

.form {
    display: flex;
    justify-content: center;

    &__container {
        width: auto;
        max-width: 450px;
        margin: 120px 20px 0;
    }

    &__header {
        text-align: center;
        margin: 70px 0;

        @include media-breakpoint-down(sm) {
            margin: 40px 5px;
        }
    }

    &__input {
        margin-top: 50px;
        @include media-breakpoint-down(sm) {
            margin-right: 20px;
            margin-left: 20px;
        }
    }
    
    &__submit {
        width: 100%;
        @include media-breakpoint-down(sm) {
            width: 100%;
            padding-right: 20px;
            padding-left: 20px;
        }
    }

    &__info {
        margin-top: 35px;
        font-size: 14px;
        color: $color-primary;
        font-weight: 400;
        width: 100%;
        margin: auto;
        // text-align: center;
        @include media-breakpoint-down(sm) {
            padding-right: 20px;
            padding-left: 20px;
        }
    }

    &__details {
        margin: 35px auto;
        width: 100%;
        display: flex;
        justify-content: center;
        text-align: center;
        
        &--icon {
            height: 35px;
            width: 35px;
        }
        &--text {
            margin: auto 10px;
            display: block;
            text-align: center;
            font-size: 16px;
            text-decoration: none;
            color: $color-main-text;
            font-weight: 400;
        }
    }
    
    &__disconnect {
        cursor: pointer;
        margin-bottom: 35px;
        &,
        &:link,
        &:visited {
            display: block;
            text-align: center;
            font-size: 12.1px;
            margin-top: 35px;
            text-decoration: none;
            color: $color-main-text;
        }
    }
}
</style>